import { QrCodeForOrganization } from "@kursk/components/pages/QrCodeForOrganization/QrCodeForOrganization";

export default function QrCodePage() {
  return <QrCodeForOrganization />;
}

export const getServerSideProps = () => {
  return { props: {} };
};
